// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import App from './App'
import router from './router'
import firebase from 'firebase'
Vue.config.productionTip = false
import store from './store/store'
import { mapGetters, mapActions } from 'vuex'
import { AppConfig } from './services'
import { sync } from 'vuex-router-sync'
const unsync = sync(store, router)
import moment from 'moment'
//import components globaly

import lodash from 'lodash'
import VueLodash from 'vue-lodash'

Vue.use(VueLodash, lodash)

import VueToastr from '@deveodk/vue-toastr'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 5000
})


/* eslint-disable no-new */
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('currency', function (value) {
  if(value){
    if(value<0)
    {
      return '-$' + Math.abs(parseFloat(value)).toFixed(2);
    }
    else
      return '$' + parseFloat(value).toFixed(2);
  }
  else
  {
    return "$0"
  }
});


Vue.filter('toUpperCase', function (value) {
  return value.toUpperCase();
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).calendar();//format('LLL')
  }
})

Vue.filter('formatUnixDate', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)) //* 1000;
    // return moment(res).calendar();//format('LLL')
    return moment.unix(res).format('ddd, MMM Do, YYYY h:mm:ss A')
    
  }
})

Vue.filter('formatEpochDateOnly', function (value) {
  if (value) {
    var res = parseInt(value) //* 1000;
    // return moment(res).calendar();//format('LLL')
    return moment.unix(res).format('ddd, MMM Do, YYYY')
    
  }
})

Vue.filter('formatUnixDateOnly', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)) //* 1000;
    // return moment(res).calendar();//format('LLL')
    return moment.unix(res).format('ddd, MMM Do, YYYY')
    
  }
})

Vue.filter('formatUnixTimeOnly', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)) //* 1000;
    // return moment(res).calendar();//format('LLL')
    return moment.unix(res).format('h:mm A')
    
  }
})

Vue.filter('resolveContact', function (value) {
  if (value) {
    let user = store.getters.contacts;
    if(user && user[value]){
        return `${user[value].displayname} (${value})`
    }    
    return value
    
  }
})



new Vue({
  el: '#vue-app',
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store,
  router,
  template: '<App/>',
  components: { App },
  // computed: {
  //   userState() {
  //     return this.$store.state.user
  //   }
  // },
  computed:mapGetters(['fcmToken']),
  // methods: mapActions(['setLocation', 'updateDealLocations', 'setSellerByReferenceName','setUser']),
  created: function () { 
    
   

    //The state here is post mutation. 
    store.subscribe((action, state) => {     

      if (action.type === "setToastMessage" && state.toastmessage) {
        var toastMessage = state.toastmessage;
        this.$toastr(toastMessage.type, toastMessage.message, toastMessage.title)
      }

    })
    
    firebase.initializeApp(process.env.FIREBASE_CONFIG)        
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
          // User is signed in.
          console.log("User signed in")
          var mapUser = {
              uid: user.uid,     // << Just the bits we need
              id: user.uid,
              email: user.email || "",
              displayName: user.displayName || "",
              name: user.displayName || "",
              // token: user.credential.accessToken || "",
              photo: user.photoURL
          }          
          store.commit('setUser', mapUser)
          store.dispatch('setDevices')
          if(!this.fcmToken)
          {
            setupmessaging()
          }

          // store.dispatch('monitorMessagesInbox')
          // store.dispatch('monitorContacts')
      } else {
          // No user is signed in.
          store.commit('setToastMessage', { type: 'info', message: `Login at any time.`, title: 'Currently logged Out' })
      }
    });

    const messaging = firebase.messaging();   
    setupmessaging()
    function setupmessaging(){
        messaging.requestPermission()
        .then(()=>{
          return messaging.getToken()
        }).then((token) => {  
          console.log('dispatching device token')             
          store.dispatch('setfcmToken', token)        
        })
        .catch((err)=> {
          console.log('Unable to get permission to notify sending false token.', err);        
          store.dispatch('setfcmToken', "ToKEN_UNSUPPORTED") 
        });  
    }

    // [START refresh_token]
      // Callback fired if Instance ID token is updated.
    messaging.onTokenRefresh(() =>{
      messaging.getToken()
      .then((refreshedToken)=>{        
        store.dispatch('setfcmToken', refreshedToken)
      })
      .catch(function(err) {
        store.dispatch('setfcmToken', "ToKEN_REFRESH_ERROR") 
      });
    });

    // [END refresh_token]
    messaging.onMessage((payload)=>{      
      this.$toastr("info", payload.notification.body, payload.notification.title);
    })
    

  }
})

// During app/Vue teardown (e.g., you only use Vue.js in a portion of your app and you 
// navigate away from that portion and want to release/destroy Vue components/resources)
// unsync() // Unsyncs store from router



// WEBPACK FOOTER //
// ./src/main.js